import { useEffect, useState } from 'react';
import { api } from '../../api';
import type { KontoListe } from './types';

// Kontenliste (SKR03-Vorschlagsliste und St-Sl-Texte) einmal je Sitzung laden; ändert sich nur mit einer neuen Version.
let cache: KontoListe | undefined;
let laden: Promise<KontoListe> | null = null;

// Konten, die meist ohne Vorsteuer gebucht werden, auf denen ein Mensch sie aber mit Hinweis nehmen darf
// (Terminalmiete, Innung mit USt). Der Server erlaubt dort 9 und 8 von Hand und zeigt den Hinweis (Prüfer R5,
// skr03.ts „vstHinweis“); Vorschläge der App bleiben ohne Vorsteuer. Ein Test im Server vergleicht die Liste.
export const VORSTEUER_MIT_HINWEIS: Readonly<Record<string, readonly string[]>> = { '4380': ['9', '8'], '4970': ['9', '8'] };

// Die Liste so, wie die Felder sie brauchen: auf diesen Konten sind 9 und 8 eintragbar
export function mitHinweisKonten(l: KontoListe): KontoListe {
  return {
    ...l,
    konten: l.konten.map((k) => {
      const bu = VORSTEUER_MIT_HINWEIS[k.nr];
      return bu && !k.automatik ? { ...k, bu: [...new Set([...k.bu, ...bu])] } : k;
    }),
  };
}

// Steht der Schlüssel auf diesem Konto nur mit Hinweis (meist ohne Vorsteuer)?
export const nurMitHinweis = (gegenkonto: string, bu: string): boolean => VORSTEUER_MIT_HINWEIS[gegenkonto]?.includes(bu) === true;

function holen(): Promise<KontoListe> {
  laden ??= api.get<KontoListe>('/api/kanzlei/buchen/kontenliste').then(
    (l) => (cache = mitHinweisKonten(l)),
    (err: unknown) => {
      // beim nächsten Mal neu versuchen
      laden = null;
      throw err;
    },
  );
  return laden;
}

// undefined, solange nicht geladen (oder fehlgeschlagen; die Felder gehen dann ohne Namen)
export function useKontenliste(): KontoListe | undefined {
  const [liste, setListe] = useState(cache);
  useEffect(() => {
    if (cache) return;
    let aktiv = true;
    holen()
      .then((l) => aktiv && setListe(l))
      .catch(() => {});
    return () => {
      aktiv = false;
    };
  }, []);
  return liste;
}

// St-Sl-Klartext („19 % Vorsteuer“)
export function buText(liste: KontoListe | undefined, bu: string | null | undefined): string | null {
  if (!bu) return null;
  return liste?.bu.find((b) => b.schluessel === bu)?.text ?? null;
}
